import React, { FC } from 'react'
import { EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'
import DemographicsSection from './DemographicsSection'
import BackgroundContentCard from './BackgroundContentCard'
import { PersonaDemographics as PersonaDemographicsType } from 'api/interfaces/Persona'

export interface PersonaInfoProps {
    demographics: PersonaDemographicsType
    triggers: string[]
    barriers: string[]
}

const PersonaInfo: FC<PersonaInfoProps> = ({ demographics, triggers, barriers }) => {
    const demographicsData = {
        'Age Range': demographics.ageRange,
        'Gender': demographics.gender,
        'Income Range': demographics.incomeRange,
        'Education': demographics.education,
        'Occupation': demographics.occupation,
        'Lifestage': demographics.lifestage,
        'Home Value': demographics.homeValue
    }

    return (
        <div>
            <EuiFlexGroup gutterSize="xl" alignItems="stretch" responsive={false}>
                <EuiFlexItem>
                    <DemographicsSection
                        demographics={demographicsData}
                        width={'100%'}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <BackgroundContentCard>
                        <EuiTitle size="xs">
                            <h4>Buying Triggers</h4>
                        </EuiTitle>
                        <EuiSpacer size="s" />
                        {triggers.map((trigger, index) => (
                            <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
                                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#343741', marginRight: '10px', marginTop: '7px', flexShrink: 0 }} />
                                <EuiText size="s">
                                    {trigger}
                                </EuiText>
                            </div>
                        ))}
                    </BackgroundContentCard>
                </EuiFlexItem>
                <EuiFlexItem>
                    <BackgroundContentCard>
                        <EuiTitle size="xs">
                            <h4>Barriers</h4>
                        </EuiTitle>
                        <EuiSpacer size="s" />
                        {barriers.map((barrier, index) => (
                            <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
                                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#343741', marginRight: '10px', marginTop: '7px', flexShrink: 0 }} />
                                <EuiText size="s">
                                    {barrier}
                                </EuiText>
                            </div>
                        ))}
                    </BackgroundContentCard>
                </EuiFlexItem>
            </EuiFlexGroup>
        </div>
    )
}

export default PersonaInfo 